import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
@Component({
  selector: 'app-add-agent-multiple',
  templateUrl: './add-agent-multiple.component.html',
  styleUrls: ['./add-agent-multiple.component.css']
})
export class AddAgentMultipleComponent implements OnInit {
  smtp: any;
  sup: any;
  form: FormGroup;
  submitted: boolean;

  constructor(protected fb: FormBuilder,@Inject(MAT_DIALOG_DATA) private data: any,private dialogRef: MatDialogRef<AddAgentMultipleComponent>) {

    this.form=this.fb.group({
      username:['',Validators.required],
      skill:['',Validators.required],
      total_agent:['',[Validators.required,this.validateNumber]],
      wrap_up_time: ['', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.minLength(1), Validators.maxLength(4), Validators.min(5), Validators.max(3600)]],
      callback_login:['0'],
      smtp_id:[0],
      mask:[1]
  
    })
   }
  //  greaterThanZero(): ValidatorFn {
  //   return (control: AbstractControl): { [key: string]: any } | null => {
  //     const value = control.value;
  //     if (value === null || value === undefined || value === '' || isNaN(value) || value <= 0) {
  //       return { 'invalidNumber': { value: control.value } };
  //     }
  //     return null;
  //   };
  // }

  validateNumber(control: AbstractControl): { [key: string]: boolean } | null {
    const value = control.value;
    if (value !== null && (isNaN(value) || value < 1 || value > 100)) {
      return { 'invalidNumber': true };
    }
    return null;
  }

  ngOnInit() {
    console.log(this.data);
    this.smtp=this.data.smtp
    this.sup=this.data.sup
    this.form.patchValue({
      wrap_up_time:this.data.data.wrap_up_time
    })
  }
  onSubmit() {
    console.log(this.form.value);
    
    this.submitted = true;
    // stop here if form is invalid
    if (this.form.invalid) {
      return;
    }

   
    this.dialogRef.close(this.form.value)
    
    this.submitted = false;
  }
  get f1() {
    return this.form.controls;
  }
  close(){
    this.dialogRef.close();
  }

}
